import { render, staticRenderFns } from "./IndividualImprintsAddDialogComponent.vue?vue&type=template&id=48e7be39&scoped=true&"
import script from "./IndividualImprintsAddDialogComponent.vue?vue&type=script&lang=js&"
export * from "./IndividualImprintsAddDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndividualImprintsAddDialogComponent.vue?vue&type=style&index=0&id=48e7be39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7be39",
  null
  
)

export default component.exports